import React from 'react';
import moment from 'moment';
import styled from 'styled-components';

export const dateInfo = (date: string) => {
  return moment(date).calendar('', {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: '[]',
    lastDay: '[Yesterday]',
    lastWeek: '[]',
    sameElse: '[]',
  });
};

const Box = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 4px;
  border: solid 1px var(--color-gunmetal);
  text-align: center;
  background-color: var(--color-white-three);
  color: #555555;
  font-family: BrandonGrotesque-Bold;
  font-stretch: condensed;
  position: absolute;
  top: 10px;
  right: 0px;
  margin: 0 auto;
  margin-right: 24px;
`;

const Month = styled.div`
  font-family: Interstate;
  margin-top: 1px;
  font-size: 11px;
  font-stretch: condensed;
`;

const Day = styled.div`
  font-family: Interstate;
  font-size: 16px;
  margin-top: -5px;
`;
const ExtraText = styled.div`
  margin: 0 auto;
  margin-top: 2px;
  font-family: BrandonGrotesque-Regular;
  font-size: 10px;
  font-weight: 300;
  font-style: normal;
  font-stretch: condensed;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: var(--color-cool-grey);
  margin-right: 24px;
  width: 35px;
`;

export default ({ date }: { date: string }) => {
  return (
    <div className="">
      <Box>
        <Month>{moment(date).format('MMM').toUpperCase()}</Month>
        <Day>{moment(date).format('D')}</Day>
        <ExtraText>{dateInfo(date)}</ExtraText>
      </Box>
    </div>
  );
};
